





























import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class BankAccountBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly openModal!: Function;

  @Prop() readonly remove!: Function;

  utilsInstance = utils;

  formatBank(number: string) {
    if (number.length === 10) {
      const positionFirst = this.addStr(number, 3, '-');
      const positionSecond = this.addStr(positionFirst, 5, '-');
      return this.addStr(positionSecond, 11, '-');
    } else {
      return number;
    }
  }

  addStr(str, index, stringToAdd) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
  }
}
